var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tls-home" },
    [
      _c("div", { staticClass: "tls-home-banner" }, [
        _c(
          "div",
          {
            staticClass: "tls-home-banner--img",
            style: {
              backgroundImage:
                "url(" +
                _vm._.get(_vm.cmsFields, "countryImage.data.full_url") +
                ")"
            }
          },
          [
            _c("div", { staticClass: "tls-home-banner--content" }, [
              _c("div", { staticClass: "tls-home-text-group" }, [
                _c(
                  "div",
                  { staticClass: "tls-simple-text -size-22 -color-white" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.cmsFields.subtitle) +
                        "\n                        "
                    ),
                    _c("img", {
                      staticClass: "tls-image",
                      attrs: {
                        src: _vm._.get(
                          _vm.cmsFields,
                          "countryFlag.data.full_url"
                        ),
                        alt: "Country flag"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "tls-heading-1" }, [
                  _vm._v(_vm._s(_vm.cmsFields.title))
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tls-home--content" },
        [
          _c("div", { staticClass: "tls-home-select" }, [
            _c("div", { staticClass: "tls-home-select--form" }, [
              _c("div", { staticClass: "tls-inline-forms" }, [
                _c("div", { staticClass: "tls-inline-forms--field" }, [
                  _c("div", { staticClass: "tls-field" }, [
                    _c("div", { staticClass: "tls-field--label" }, [
                      _c("label", { staticClass: "tls-label" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.cmsFields.selectInstruction) +
                            "\n                                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tls-field--area" }, [
                      _c("div", { staticClass: "tls-input-select-container" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.residenceCountrySelected,
                                expression: "residenceCountrySelected"
                              }
                            ],
                            staticClass: "tls-input-select",
                            attrs: {
                              "data-tls-value": "select-residencecountry"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.residenceCountrySelected = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                staticClass: "tls-input-select-option",
                                attrs: { selected: "", disabled: "", value: "" }
                              },
                              [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.cmsFields.selectDefaultOption) +
                                    "\n                                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.countryCMSData, function(country) {
                              return _c(
                                "option",
                                {
                                  key: country.code,
                                  staticClass: "tls-input-select-option",
                                  domProps: { value: country.code }
                                },
                                [
                                  _vm._v(
                                    _vm._s(country.country_name_translation) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tls-inline-forms--button" }, [
                        _c(
                          "button",
                          {
                            staticClass: "tls-button-primary -small",
                            attrs: {
                              "data-tls-value": "submit-residencecountry"
                            },
                            on: { click: _vm.submit }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm._.get(_vm.keywords, "submit")) +
                                "\n                                    "
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-home-select--footer" }, [
              _c("div", { staticClass: "tls-simple-text -size-12" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.cmsFields.selectWarning) +
                    "\n                "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          Object.keys(_vm.swiperOption).length &&
          _vm._.get(_vm.cmsFields, "carousel")
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper el-carousel -pc",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(_vm._.get(_vm.cmsFields, "carousel"), function(
                  carousel
                ) {
                  return _c(
                    "swiper-slide",
                    {
                      key: _vm._.get(carousel, "img_link"),
                      staticClass: "swiper-slide"
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: _vm._.get(carousel, "link") } },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm._.get(carousel, "img_link"),
                              alt: ""
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.swiperOption).length &&
          _vm._.get(_vm.cmsFields, "carousel_mobile")
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper el-carousel -mobile",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(_vm._.get(_vm.cmsFields, "carousel_mobile"), function(
                  carousel
                ) {
                  return _c(
                    "swiper-slide",
                    {
                      key: _vm._.get(carousel, "img_link"),
                      staticClass: "swiper-slide"
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: _vm._.get(carousel, "link") } },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm._.get(carousel, "img_link"),
                              alt: ""
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-title": _vm.cmsFields.popupTitle,
              "popup-data": { simpleText: _vm.cmsFields.popupContent },
              "popup-data-language-alert": {
                simpleText: _vm.popupLanguageAlertMsg
              }
            },
            on: {
              "confirm-action": _vm.confirmCountry,
              "close-action": _vm.cancelCountryChoice
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAlertPopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-title": _vm.cmsFields.popupTitle,
              "popup-data": {
                simpleText: _vm.cmsFields.popupContentNotSelectResidenceCountry
              },
              hasConfirmAction: false
            },
            on: { "close-action": _vm.cancelChoice }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoginErrorPopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-data": {
                simpleText: _vm.$t("invalid_rediret_home_page_popup_content")
              },
              hasCancelAction: false
            },
            on: {
              "confirm-action": function($event) {
                _vm.showLoginErrorPopup = false
              },
              "close-action": function($event) {
                _vm.showLoginErrorPopup = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showOpenIssuerHomePagePopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-data": {
                simpleText: _vm.$t("valid_rediret_home_page_popup_content", {
                  country: _vm.localStorageCountryName,
                  center: _vm.localStorageIssuerName
                })
              }
            },
            on: {
              "confirm-action": function($event) {
                return _vm.gotoIssuerHomePage()
              },
              "cancel-action": function($event) {
                _vm.showOpenIssuerHomePagePopup = false
              },
              "close-action": function($event) {
                _vm.showOpenIssuerHomePagePopup = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-home-banner--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }